import axiosInstance from '../../components/api/axiosInstance';

export const billingService = {
  getTrialStatus: () =>
    axiosInstance.get('/api/billing/trial-status').then((r) => r.data),

  getPaymentMethod: () =>
    axiosInstance.get('/api/billing/payment-method').then((r) => r.data),

  setupPaymentMethod: (paymentMethodId) =>
    axiosInstance.post('/api/billing/payment-method/setup', { paymentMethodId }).then((r) => r.data),

  removePaymentMethod: () =>
    axiosInstance.delete('/api/billing/payment-method').then((r) => r.data),

  getBillingPreview: () =>
    axiosInstance.get('/api/billing/preview').then((r) => r.data),

  calculateNextBill: () =>
    axiosInstance.get('/api/billing/calculate').then((r) => r.data),

  getBillingSummary: () =>
    axiosInstance.get('/api/billing/summary').then((r) => r.data),

  generateInvoice: () =>
    axiosInstance.get('/api/billing/invoice/generate').then((r) => r.data),

  calculateProration: (newPlan) =>
    axiosInstance.post('/api/billing/calculate-proration', { newPlan }).then((r) => r.data),

  calculateIrisProCostImpact: (userIdsToAdd = [], userIdsToRemove = []) =>
    axiosInstance.post('/api/billing/iris-pro/cost-impact', { userIdsToAdd, userIdsToRemove }).then((r) => r.data),

  getBillingHistory: (params = {}) =>
    axiosInstance.get('/api/billing/history', { params }).then((r) => r.data),

  getInvoices: (params = {}) =>
    axiosInstance.get('/api/billing/invoices', { params }).then((r) => r.data),

  extendTrial: (days) =>
    axiosInstance.post('/api/billing/extend-trial', { days }).then((r) => r.data),

  upgradeFromTrial: (confirmation = {}) =>
    axiosInstance.post('/api/billing/upgrade', confirmation).then((r) => r.data),

  cancelSubscription: () =>
    axiosInstance.post('/api/billing/cancel').then((r) => r.data),

  reactivateSubscription: () =>
    axiosInstance.post('/api/billing/reactivate').then((r) => r.data),
};
